import {Component, Input, OnInit} from "@angular/core";
import {DialogComponent} from "../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {TagsListDialogComponent} from "../tags-list-dialog/tags-list-dialog.component";
import {WebsiteService} from "../../website.service";
import {DbResponse} from "../../../shared/interceptors/db-response";
import {filter} from "rxjs/operators";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../store';

@Component({
    selector: 'db-remove-tag-dialog',
    templateUrl: './remove-tag-dialog.component.html',
    styleUrls: ['./remove-tag-dialog.component.scss'],
    standalone: false
})
export class RemoveTagDialogComponent extends DialogComponent<null, Boolean> implements OnInit {
  public loading: boolean;
  public isMobile: boolean;
  @Input() tagId: number;
  @Input() tagTitle: string;
  @Input() domainIds?: any;

  constructor(
    private _dialogService: DialogService,
    private _websiteService: WebsiteService,
    private _store: Store<fromStore.DbStoreState>
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 991;
  }

  public confirm(): void {
    this.loading = true;
    this._websiteService.removeUserTag(this.tagId)
      .pipe(
        filter((response: DbResponse): boolean => !!response)
      )
      .subscribe((response: DbResponse): void => {
        if ( response.success ) {
          this._store.dispatch( new fromStore.LoadWebsites() );
          this._store.dispatch( new fromStore.LoadWebsiteTags() );
          this.cancel(true);
        }
        this.loading = false;
      });
  }

  public cancel(removed): void {
    this.close();
    this._dialogService.addDialog(TagsListDialogComponent, {
      removedTagId: removed && this.tagId ? this.tagId : null,
      domainIds: this.domainIds
    });
  }

}
